import React from "react";
import './CopyAllButton.css'

export default function CopyAllButton({ onClick }) {
  return (
    <button onClick={onClick} className="copy-all-button">
      Copy tất cả
    </button>
  );
}